import { ButtonSet, Form, Loading } from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm, FieldErrors } from "react-hook-form";
import CancelButton from "../../components/Buttons/CancelButton";
import SubmitButton from "../../components/Buttons/SubmitButton";
import http from "../../http-common";
import Card from "../../components/Card/Card";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { Tabs } from "carbon-components-react";
import { Tab } from "carbon-components-react";
import { Button } from "carbon-components-react";
import { ArrowRight20 } from "@carbon/icons-react";
import { ArrowLeft20 } from "@carbon/icons-react";
import { basicCandidatureSchema } from "../../services/SchemaService";
import { yupResolver } from "@hookform/resolvers/yup";
import ProjectDetailsForm from "../../components/Forms/ProjectDetailsForm";
import ApplicationDisclaimer from "../../components/Miscellaneous/ApplicationDisclaimer";
import { toast } from "react-toastify";
import TeamForm from "../../components/Forms/TeamForm";
import DocumentForm from "../../components/Forms/DocumentForm";
import CompanyDetailsForm from "../../components/Forms/CompanyDetailsForm";

const CreateCandidaturePage = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState(0);
  const [documents, setDocuments] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    reset,
    handleSubmit,
    setValue,
    control,
    formState: { errors, isSubmitted },
  } = useForm({
    resolver: yupResolver(basicCandidatureSchema),
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      const submissionData = {
        ...data,
        documents: documents,
        teamMembers: teamMembers,
      };

      const response = await http.post("/applications", submissionData);
      toast.success("Candidatura Registada com sucesso");
      navigate("../candidature/" + response.data);
    } catch (error) {
      toast.error(error?.response?.data.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Helper function to convert File to Base64
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // Extract the base64 data (remove the data:application/pdf;base64, prefix)
        const base64String = reader.result.split(",")[1];
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const nextTab = () => {
    setActiveTab((prev) => prev + 1);
  };
  const previousTab = () => {
    setActiveTab((prev) => prev - 1);
  };

  const getCandidatureUuid = async () => {
    try {
      const response = await http.get(`/applications/load-user-application`);
      navigate("../candidature/" + response.data.uuid);
    } catch (error) {}
  };

  useEffect(() => {
    getCandidatureUuid();
  }, [user]);

  return (
    <Card title="Registar Candidatura">
      <Loading
        active={isSubmitting}
        description="Active loading indicator"
        withOverlay={true}
      />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Tabs
          scrollIntoView={false}
          selected={activeTab}
          type={"container"}
          onSelectionChange={(e) => setActiveTab(e)}
        >
          <Tab href="#" id="tab-0" label="Declaração">
            <ApplicationDisclaimer />
            <div className="tab-navigation">
              <p></p>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-0" label="Dados da Empresa">
            <CompanyDetailsForm
              reset={reset}
              register={register}
              errors={errors}
              control={control}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-3" label="Dados do Projecto">
            <ProjectDetailsForm register={register} errors={errors} />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-3" label="Equipa do Projecto">
            <TeamForm
              teamMembers={teamMembers}
              setTeamMembers={setTeamMembers}
              isUpdate={false}
              applicationUuid={null}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-3" label="Documentos">
            <DocumentForm
              documents={documents}
              setDocuments={setDocuments}
              isUpdate={false}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
            </div>
          </Tab>
        </Tabs>
        <ButtonSet>
          <SubmitButton className={"emprega-bg-green"} />
          <CancelButton />
        </ButtonSet>
        {/* )} */}
      </Form>
    </Card>
  );
};

export default CreateCandidaturePage;
